/**
 * Industries We Serve Tab & Infinite Slider Functionality
 */

document.addEventListener('DOMContentLoaded', () => {
    const tabs = document.querySelectorAll('.industry-tab');

    if (!tabs.length) return;

    // 1. Tab Switching Functionality (Context-Aware)
    function activateTab(tab) {
        const targetId = tab.getAttribute('data-target');
        const isDesktop = tab.closest('.industries-serve--desktop-only') !== null;
        
        // Find the context (desktop or mobile container)
        const context = isDesktop 
            ? document.querySelector('.industries-serve--desktop-only') 
            : document.querySelector('.industries-serve--mobile-only');

        if (!context) return;

        // Deactivate current active tab in this context
        context.querySelectorAll('.industry-tab.active').forEach(t => t.classList.remove('active'));
        
        // Deactivate current active content in this context
        // Check for desktop unique class or mobile tab-content
        context.querySelectorAll('.indus-desktop-content-item.active, .tab-content.active').forEach(c => c.classList.remove('active'));

        // Activate clicked tab
        tab.classList.add('active');
        
        // Activate target content
        const targetContent = document.getElementById(targetId);
        if (targetContent) {
            targetContent.classList.add('active');
        }

        // Smooth scroll for mobile tabs
        if (!isDesktop) {
            tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
    }

    tabs.forEach(tab => {
        tab.addEventListener('click', () => activateTab(tab));
    });

    // 2. Continuous Loop Sliding Logic (Mobile only)
    const mobileGrids = document.querySelectorAll('.industries-serve--mobile-only .industries-grid');
    if (mobileGrids.length && window.innerWidth <= 991) {
        mobileGrids.forEach(grid => initInfiniteScroll(grid));
    }

    function initInfiniteScroll(container) {
        const items = Array.from(container.children);
        
        // Clone items for loop
        items.forEach(item => {
            const cloneNode = item.cloneNode(true);
            cloneNode.addEventListener('click', () => activateTab(cloneNode));
            container.appendChild(cloneNode);
        });

        items.reverse().forEach(item => {
            const cloneNode = item.cloneNode(true);
            cloneNode.addEventListener('click', () => activateTab(cloneNode));
            container.prepend(cloneNode);
        });

        const originalWidth = items[0].offsetWidth * items.length;
        container.scrollLeft = originalWidth;

        container.addEventListener('scroll', () => {
            if (container.scrollLeft <= 5) {
                container.scrollLeft = originalWidth;
            } else if (container.scrollLeft >= originalWidth * 2 - 5) {
                container.scrollLeft = originalWidth;
            }
        });

        // Drag to scroll
        let isDown = false;
        let startX;
        let scrollLeft;

        container.addEventListener('mousedown', (e) => {
            isDown = true;
            container.classList.add('is-dragging');
            startX = e.pageX - container.offsetLeft;
            scrollLeft = container.scrollLeft;
        });
        container.addEventListener('mouseleave', () => {
            isDown = false;
            container.classList.remove('is-dragging');
        });
        container.addEventListener('mouseup', () => {
            isDown = false;
            container.classList.remove('is-dragging');
        });
        container.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - container.offsetLeft;
            const walk = (x - startX) * 2; 
            container.scrollLeft = scrollLeft - walk;
        });
    }
});
